"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _basic = _interopRequireDefault(require("./_basic"));
var _bluebird = _interopRequireDefault(require("bluebird"));
class UrlShortenerApi extends _basic.default {
  /**
   * @constructor
   */
  constructor(_ref) {
    let {
      userTokenFactory,
      urlShortenerUrl,
      accountId
    } = _ref;
    super({
      userTokenFactory
    });
    this.urlShortenerUrl = urlShortenerUrl;
    this.accountId = accountId;
  }
  async createShortUrl(_ref2) {
    let {
      url,
      deepLink = false,
      accountId = this.accountId
    } = _ref2;
    const headers = await this.getHeaders();
    return _bluebird.default.try(() => _axios.default.post(`${this.urlShortenerUrl}/acc/${accountId}/link`, {
      url,
      deepLink
    }, headers).then(response => _bluebird.default.resolve(response.data)));
  }
  async updateShortUrl(_ref3) {
    let {
      url,
      shortUrl,
      deepLink,
      accountId = this.accountId
    } = _ref3;
    const headers = await this.getHeaders();
    return _bluebird.default.try(() => _axios.default.put(`${this.urlShortenerUrl}/acc/${accountId}/link`, {
      url,
      deepLink,
      shortUrl
    }, headers).then(response => _bluebird.default.resolve(response.data)));
  }
  async deleteShortUrl(_ref4) {
    let {
      shortUrl,
      accountId = this.accountId
    } = _ref4;
    const headers = await this.getHeaders();
    return _bluebird.default.try(() => _axios.default.delete(`${this.urlShortenerUrl}/acc/${accountId}/link`, {
      shortUrl
    }, headers).then(response => _bluebird.default.resolve(response.data)));
  }
}
var _default = UrlShortenerApi;
exports.default = _default;